var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHhIconUnbranded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.999 187.633"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 135",
    d: "M239.869 157.235V65.85c0-12.922.76-22.043 10.13-30.15h-47.12c9.376 8.107 10.136 17.228 10.136 30.15v18.673h-26.7V30.151c0-12.923.76-22.043 10.13-30.151h-47.116c9.377 8.107 10.136 17.228 10.136 30.151v54.372H90.538V30.151c0-12.923.758-22.043 10.136-30.151H53.55c9.375 8.107 10.134 17.228 10.134 30.151v54.372h-26.7V65.85c0-12.922.758-22.043 10.136-30.15H0c9.375 8.107 10.134 17.228 10.134 30.15v91.385c0 12.92-.759 22.039-10.134 30.4h47.125c-9.378-8.359-10.136-17.478-10.136-30.4v-52.949h26.7v52.949c0 12.92-.759 22.039-10.134 30.4h47.125c-9.378-8.359-10.136-17.478-10.136-30.4v-52.949h68.918v52.949c0 12.92-.759 22.039-10.136 30.4h47.121c-9.37-8.359-10.13-17.478-10.13-30.4v-52.949h26.7v52.949c0 12.92-.76 22.039-10.136 30.4h47.12c-9.372-8.361-10.132-17.48-10.132-30.4z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "5f80fd72a6047f821e3ddcb00b05fa55.svg";
export { SvgHhIconUnbranded as ReactComponent };